import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

// Styles
import { padding, colors, radius } from '../../styles/variables';

const useStyles = makeStyles({
  root: {
    minWidth: '23.6rem',
    width: '23.6rem',
    height: '20rem',
    backgroundColor: 'transparent',
    margin: `${padding.v}`,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translate(0px, -1rem)',
    },
  },
  cardIntWrapper: {
    borderRadius: radius.default,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: '1.5rem',
    background: props => props.cardColor,
    boxSizing: 'border-box',
    '&:last-child': {
      paddingBottom: '1.5rem',
    },
  },
  title: {
    wordBreak: 'break-word',
    fontSize: '3.2rem',
    fontWeight: '300',
    color: colors.white,
    lineHeight: '1.13',
    padding: '0',
  },
  assetNumber: {
    fontSize: '1.2rem',
    fontWeight: '400',
    color: colors.white,
    padding: '0',
  },
});

export default function StoryboardCard(props) {
  const classes = useStyles(props);

  function handleClick() {
    const { onClick } = props;
    onClick();
  }

  const { cardTitle, assetNumber } = props;
  return (
    <Card className={classes.root} onClick={handleClick}>
      <CardContent className={classes.cardIntWrapper}>
        <Typography className={classes.title}>
          {cardTitle && cardTitle.length > 25
            ? cardTitle.substring(0, 23) + '...'
            : cardTitle}
        </Typography>
        <Typography
          variant='body2'
          component='p'
          className={classes.assetNumber}>
          {assetNumber}
        </Typography>
      </CardContent>
    </Card>
  );
}

StoryboardCard.propTypes = {
  onClick: PropTypes.func,
  cardTitle: PropTypes.string,
  assetNumber: PropTypes.string,
};
